import { CardButton, LayoutContentBody, Typography } from '@pinwheel/origami';
import React from 'react';
import CompanyIcon from './CompanyIcon';
import { noop } from '../utils';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
var ProviderButton = function (_a) {
    var logoUrl = _a.logoUrl, eventId = _a.eventId, employerName = _a.employerName, platformName = _a.platformName, _b = _a.onClick, onClick = _b === void 0 ? noop : _b, dataTestId = _a["data-testid"];
    // Apply an accessible name to the button container. Since the label (platform name)
    // is already present on the DOM, use `aria-labelledby` instead of `aria-label`.
    var labelId = "ProviderButton".concat(platformName);
    var getLocalizedString = useGetLocalizedString();
    return (React.createElement(CardButton, { "data-testid": dataTestId, onClick: function () { return onClick(); }, sx: { padding: 0, margin: '8px 0' }, eventId: eventId, "aria-labelledby": labelId, wrapHtmlTag: "div" },
        React.createElement("div", { style: {
                padding: '8px',
                display: 'flex',
                alignItems: 'center',
            } },
            React.createElement(CompanyIcon, { result: {
                    logoUrl: logoUrl,
                    name: platformName,
                } }),
            React.createElement(LayoutContentBody, null,
                React.createElement(Typography, { sx: { marginLeft: '8px' }, weight: "normal", variant: "label", align: "left", color: "title", id: labelId }, employerName || platformName),
                employerName ? (React.createElement(Typography, { sx: { marginLeft: '8px' }, weight: "normal", variant: "caption", align: "left", id: labelId, color: "light" }, getLocalizedString('PAYROLL_PROVIDED_BY', [platformName]))) : null))));
};
export default ProviderButton;
